module.exports = __webpack_public_path__ + "img/icon_punched-card2.d16896e4.svg";